module.exports = __webpack_public_path__ + "static/media/preload_logo.ed472bf3.png";